"use strict";
require("next/dist/build/polyfills/polyfill-nomodule");

//# sourceMappingURL=polyfills.js.map